import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { allCourses, featuredCourse, bonusAgents } from '../../mocks/courses';
import { Link, useNavigate } from 'react-router-dom';
import SchemaOrg from '../../components/base/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const cursosSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Cursos de IA para Professores — ViaEducacaoCursos',
  description:
    'Formação completa em Inteligência Artificial para educadores: ChatGPT, Gemini e agentes de IA para a prática pedagógica.',
  url: `${siteUrl}/cursos`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      item: {
        '@type': 'Course',
        name: 'ChatGPT e Gemini para Professores',
        description:
          'Curso prático para professores aprenderem a usar ChatGPT e Gemini no planejamento, criação de materiais e avaliação.',
        url: `${siteUrl}/curso-detalhado`,
        provider: {
          '@type': 'Organization',
          name: 'ViaEducacaoCursos',
          url: siteUrl,
        },
        offers: {
          '@type': 'Offer',
          price: '147.00',
          priceCurrency: 'BRL',
          availability: 'https://schema.org/InStock',
        },
        inLanguage: 'pt-BR',
      },
    },
  ],
};

export default function CursosPage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'ViewContent', {
        content_name: 'Curso ChatGPT e Gemini para Professores',
        content_category: 'Cursos',
        content_ids: ['curso-chatgpt-gemini'],
        content_type: 'product',
        value: 147.00,
        currency: 'BRL',
      });
    }
  }, []);

  const handleCheckoutClick = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        value: 147.00,
        currency: 'BRL',
        content_name: 'Curso ChatGPT e Gemini para Professores',
        content_ids: ['curso-chatgpt-gemini'],
        content_type: 'product',
        num_items: 1,
      });
      window.fbq('track', 'InitiateCheckout', {
        value: 147.00,
        currency: 'BRL',
        content_name: 'Curso ChatGPT e Gemini para Professores',
        content_ids: ['curso-chatgpt-gemini'],
        content_type: 'product',
        num_items: 1,
      });
    }
    window.open('https://pay.hotmart.com/W100719375C?off=w6t3o2lu', '_blank', 'noopener,noreferrer');
    navigate('/obrigado');
  };

  return (
    <div className="min-h-screen">
      <SchemaOrg id="cursos" schema={cursosSchema} />
      <Navbar />
      <main>
        <section className="pt-32 pb-20 bg-gradient-to-b from-purple-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
                Nossos Cursos
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Formação completa em Inteligência Artificial para educadores que desejam transformar sua prática pedagógica
              </p>
            </div>

            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden mb-16">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                <div className="relative h-96 lg:h-auto">
                  <img
                    src={featuredCourse.image}
                    alt={featuredCourse.title}
                    className="w-full h-full object-cover"
                  />
                  <span className="absolute top-6 right-6 px-4 py-2 bg-orange-500 text-white text-sm font-bold rounded-full">
                    {featuredCourse.badge}
                  </span>
                </div>
                <div className="p-10 lg:p-12 flex flex-col justify-center">
                  <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                    {featuredCourse.title}
                  </h2>
                  <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                    {featuredCourse.description}
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8">
                    {featuredCourse.features.map((feature, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <i className="ri-checkbox-circle-fill text-green-500 text-lg"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div className="flex items-center gap-6">
                    <span className="text-4xl font-bold text-purple-600">
                      {featuredCourse.price}
                    </span>
                    <button
                      onClick={handleCheckoutClick}
                      className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-full hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                    >
                      Inscrever-se Agora
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-16">
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                Bônus Exclusivos Inclusos
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {bonusAgents.map((agent) => (
                  <div key={agent.id} className="bg-white rounded-3xl shadow-xl overflow-hidden">
                    <div className="relative">
                      <div className="w-full h-64">
                        <img
                          src={agent.image}
                          alt={agent.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <span className="absolute top-4 left-4 px-3 py-1 bg-purple-600 text-white text-xs font-bold rounded-full flex items-center gap-1">
                        <i className="ri-star-fill"></i>
                        {agent.badge}
                      </span>
                    </div>
                    <div className="p-8">
                      <h4 className="text-2xl font-bold text-gray-900 mb-3">
                        {agent.title}
                      </h4>
                      <p className="text-gray-600 leading-relaxed">
                        {agent.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                Outros Cursos Disponíveis
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {allCourses.map((course) => (
                  <div key={course.id} className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
                    <div className="h-56">
                      <img
                        src={course.image}
                        alt={course.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-6">
                      <h4 className="text-xl font-bold text-gray-900 mb-3">
                        {course.title}
                      </h4>
                      <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                        {course.description}
                      </p>
                      <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {course.duration}
                        </span>
                        <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">
                          {course.level}
                        </span>
                      </div>
                      <button
                        onClick={handleCheckoutClick}
                        className="block w-full py-3 bg-gray-900 text-white font-semibold rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap text-center cursor-pointer"
                      >
                        Saiba Mais
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-gradient-to-r from-purple-600 to-blue-600">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Pronto para transformar sua prática pedagógica?
            </h2>
            <p className="text-xl text-purple-100 mb-8">
              Junte-se a centenas de educadores que já estão usando IA de forma intencional
            </p>
            <button
              onClick={handleCheckoutClick}
              className="inline-block px-10 py-4 bg-white text-purple-600 font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Começar Agora
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}